module.exports = __webpack_public_path__ + "img/assets.1476c788.jpg";